import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { translate } from '../../utils/util';
import { ENUMS } from '../../utils/constants';
import LinePickingService from '../../services/LinePickingService';
import { SelectItem } from './ComponentsUI';

const SelectMapping = (props) => {
    const [mapping, setMapping] = useState([]);

    useEffect(() => {
        props.getMappingRegistrationAll({ mappingRegistrationTypeId: props.mappingType }, (data) => {
            setMapping([...data]);
        });
        // eslint-disable-next-line
    }, []);

    const renderLabel = () => {
        switch (props.mappingType) {
            case ENUMS.eMappingRegistrationType.Class.value:
                return translate('mapping:class', 'line-picking');
            case ENUMS.eMappingRegistrationType.Parts.value:
                return translate('mapping:parts', 'line-picking');
            case ENUMS.eMappingRegistrationType.Gravitational.value:
                return translate('mapping:gravitational', 'line-picking');
            case ENUMS.eMappingRegistrationType.Line.value:
                return translate('mapping:line', 'line-picking');
            default:
                return translate('mapping:class', 'line-picking')
        }
    }

    const onChange = (event) => {
        if (props.onChange) {
            props.onChange(event);
        }
    }

    return (
        <SelectItem
            {...props}
            id={props.name}
            defaultValue={props.defaultValue ? props.defaultValue.toString() : ''}
            label={renderLabel()}
            placeHolder={translate('general:choose-one-option')}
            minLength={0}
            onChange={onChange}
            onChangeData={onChange}
            changeEvent="true"
            data={mapping ? mapping.map((i) => {
                return {
                    id: i.code, text: props.showCode ? i.code : i.description
                };
            }) : []} />
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getMappingRegistrationAll: (filter, callback) => {
            dispatch(LinePickingService.getMappingRegistrationAll(filter, callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SelectMapping));
